<div class="flex wrap gap-[4px] items-center" data-at-snapshot-synchronize>
  <button
    mat-stroked-button
    (click)="kanbanBoardStore.recreateSnapshot()"
    gtm="onSelect"
    gtmAction="Recreate snapshot"
    gtmCategory="Dashboard"
  >
    <span class="flex items-center">
      <mat-icon class="refresh-icon">refresh</mat-icon>
      <span>{{
        'DASHBOARD.DASHBOARD_WELCOME.GREETING.BUTTONS.SYNCHRONIZE_BUTTON' | translate
      }}</span>
    </span>
  </button>
  <mat-icon
    [matTooltip]="'DASHBOARD.DASHBOARD_WELCOME.GREETING.BUTTONS.SYNCHRONIZE_TOOLTIP' | translate"
    >info_outline</mat-icon
  >
</div>
